import './DealItem.scss';
import { NavLink, Outlet, useLoaderData } from 'react-router-dom';
import { ReactComponent as DocIcon } from '../../assets/img/docIcon.svg';
import { useState, useEffect } from 'react';
import Chat from '../Chat/Chat';
import CustomLoader from '../../components/CustomLoader/CustomLoader';
import { loadDealById } from '../../utils/utilsApi';
import { SEND_DATA_TO_PARENT_WINDOW } from '../../utils/utils';
import {
  loadDealByIdCustom,
  loadDocumentTypes,
} from '../../utils/mainWizardApi';
import { dataObject } from '../../utils/mock';

export async function loader(loaderData: { params: any }) {
  return loaderData.params.id;
}

const DealItem = () => {
  const [dataItem, setDataItem] = useState<any>(dataObject);
  const [loading, setLoading] = useState(false);
  const [isTokenLoaded, setIsTokenLoaded] = useState(false);

  const [uploadedFilesLength, setUploadedfilesLength] = useState(0);

  // Лоадер передает эти данные из router-dom при загрузке компонента
  const id: any = useLoaderData();

  // Запрос с APi данных по Id задачи
  const loadedByIdResultFunc = (value: any) => {
    console.log(value);
    //При неверном запросе приходит ответ формата {status: false, data: false, errro: ''} определяю что это ошибка
    if (value.data.status === true) {
      setDataItem(Object.assign({}, value.data.data.entry));
    } else {
      setDataItem(false);
    }

    setLoading(false);
  };

  const checkApi = () => {
    if (localStorage.getItem('accessToken')) {
      loadDealByIdCustom(
        localStorage.getItem('accessToken'),
        Number(id),
        loadedByIdResultFunc
      );
    }
  };

  const checkDocumentTypes = () => {
    if (localStorage.getItem('accessToken')) {
      loadDocumentTypes(localStorage.getItem('accessToken'), () =>
        console.log('success')
      );
    }
  };

  //При отрисовке запускаю функцую загрузки данных по ID с Api
  /*   useEffect(() => {
    id[0] === '№'
      ? loadDealById(
          token,
          Number(id.slice(1, id.length)),
          loadedByIdResultFunc
        )
      : loadDealById(token, Number(id), loadedByIdResultFunc);
    setLoading(true);
  }, []); */

  /*   useEffect(() => {
    id[0] === '№'
      ? loadDealById(
          token,
          Number(id.slice(1, id.length)),
          loadedByIdResultFunc
        )
      : loadDealById(token, Number(id), loadedByIdResultFunc);
  }, [id]); */

  // Утсанваливаю новое кол-во файлов при изменении данных
  /*   useEffect(() => {
    if (dataItem) {
      setUploadedfilesLength(dataItem.files_groups.my.length);
    }
  }, [dataItem]); */

  useEffect(() => {
    // Проверка токена и запрос, если его нет
    if (localStorage.getItem('accessToken')) {
      setIsTokenLoaded(true);
      //loadDealById(token, Number(id), loadedByIdResultFunc);
    } else if (!localStorage.getItem('accessToken')) {
      SEND_DATA_TO_PARENT_WINDOW('loadded');
      setTimeout(() => {
        if (!localStorage.getItem('accessToken')) {
          SEND_DATA_TO_PARENT_WINDOW('loadded');
        }
      }, 3000);
    }
  }, [isTokenLoaded]);

  return (
    <div className="deal-item">
      {dataItem && loading === false ? (
        <>
          <h1 className="deal-item__name">{dataItem.attributes.theme}</h1>
          <div className="deal-item__header">
            <span className="deal-item__number">{'№ ' + dataItem.id}</span>
            <span className="deal-item__work-type">
              {dataItem.attributes.typeofWork}
            </span>
            <span className="deal-item__course">
              {dataItem.attributes.course}
            </span>
            <span className="deal-item__type">
              {dataItem.attributes.status}
            </span>
          </div>
          <div className="deal-item__wrapper">
            <div className="deal-item__wrapper-header">
              <ul className="deal-item__header-list">
                <li className="deal-item__header-item">
                  <NavLink
                    to={'/deals/' + id}
                    end
                    className={({ isActive }) =>
                      isActive
                        ? 'deal-item__header-link active'
                        : 'deal-item__header-link'
                    }
                  >
                    <span className="deal-item__header-name">
                      Требования к работе
                    </span>
                    <DocIcon className="deal-item__header-icon" />
                  </NavLink>
                </li>
                <li className="deal-item__header-item">
                  <NavLink
                    to={'/deals/' + id + '/files'}
                    className={({ isActive }) =>
                      isActive
                        ? 'deal-item__header-link deal-item__header-link--files-count active'
                        : 'deal-item__header-link deal-item__header-link--files-count'
                    }
                  >
                    <span className="deal-item__header-name">
                      Файлы от клиента
                    </span>
                    <DocIcon className="deal-item__header-icon" />
                    {/* <span className="deal-item__files-count">
                      {dataItem.count_files}
                    </span> */}
                  </NavLink>
                </li>
                <li className="deal-item__header-item">
                  <NavLink
                    to={'/deals/' + id + '/yourfiles'}
                    className={({ isActive }) =>
                      isActive
                        ? 'deal-item__header-link active'
                        : 'deal-item__header-link'
                    }
                  >
                    <span className="deal-item__header-name">Ваши файлы</span>
                    <DocIcon className="deal-item__header-icon" />
                    <span className="deal-item__your-files-count">
                      {uploadedFilesLength}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
            <Outlet />
          </div>
          {/* <Chat /> */}
        </>
      ) : dataItem === false && loading === false ? (
        <>
          <div>
            Такого номера заказа не существует, проверьте введенные данные и
            попробуйте снова
          </div>
          <button type="button" onClick={checkApi}>
            CheckApiOrders
          </button>
          <button type="button" onClick={checkDocumentTypes}>
            CheckApiDocumentTypes
          </button>
        </>
      ) : (
        <CustomLoader width={100} height={100} />
      )}
    </div>
  );
};

export default DealItem;
